export const EDIT_LAYOUT_TYPES = {
  left_align: 'left_align',
  right_align: 'right_align',
  one_column: 'one_column',
  reg31_left_align: 'reg31_left_align',
  reg31_right_align: 'reg31_right_align',
  reg30: 'reg30',
};

export const EDIT_LAYOUT_DATA = [
  {
    id: 1,
    layoutType: 'reg30',
    description: 'twoColRightDesc',
    dataTestId: 'RegBuilder_reg30CarouselLabel',
    title: 'Carousel',
    version: '3.0',
  },
  {
    id: 2,
    layoutType: 'reg31_left_align',
    description: 'twoColLeftDesc',
    dataTestId: 'RegBuilder_reg31twoColumnLeftLabel',
    title: 'TwoColumnLeft',
    version: '3.0',
  },
  {
    id: 3,
    layoutType: 'reg31_right_align',
    description: 'twoColRightDesc',
    dataTestId: 'RegBuilder_reg31twoColumnRightLabel',
    title: 'TwoColumnRight',
    version: '3.0',
  },
  {
    id: 4,
    layoutType: 'left_align',
    description: 'twoColLeftDesc',
    dataTestId: 'RegBuilder_twoColumnLeftLabel',
    title: 'LegacyTwoColumnLeft',
    version: '2.0',
  },
  {
    id: 5,
    layoutType: 'right_align',
    description: 'twoColRightDesc',
    dataTestId: 'RegBuilder_twoColumnRightLabel',
    title: 'LegacyTwoColumnRight',
    version: '2.0',
  },
  {
    id: 6,
    layoutType: 'one_column',
    description: 'oneColDesc',
    dataTestId: 'RegBuilder_oneColumnLabel',
    title: 'LegacyOneColumn',
    version: '2.0',
  },
];

export const resolveEditLayoutData = (includeV2) => {
  let layoutData = EDIT_LAYOUT_DATA.filter((layout) => layout.version === '3.0');
  if (includeV2) {
    layoutData = EDIT_LAYOUT_DATA;
  }

  return layoutData;
};
